<template>
  <div class="calculator__items">
    <div class="calculator__item calculator__item_active calculator__item_pay-step">
      <div class="calculator__item-content">
        <div class="calculator__cols">
          <div class="calculator__col">
            <div class="calc-pay__title">
              Ваше отправление
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Откуда
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.sender.pointAddress }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Отправитель
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.sender.name }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Куда
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.receiver.pointAddress }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Получатель
              </div>
              <div class="calc-pay__item__text">
                {{ orderPIP.receiver.name }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Вес посылки
              </div>
              <div class="calc-pay__item__text">
                {{ orderCalcPIP.weight }} кг
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Ценность посылки
              </div>
              <div class="calc-pay__item__text">
                {{ orderCalcPIP.public_price }} {{ isDirectionKzKz ? '₸' : 'руб.' }}
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Срок доставки
              </div>
              <div class="calc-pay__item__text">
                {{ checkDeliveryMethod.time }}&nbsp;
                {{ num2str(checkDeliveryMethod.time, [' рабочий', ' рабочих', ' рабочих']) }}
                {{ num2str(checkDeliveryMethod.time, [' день', ' дня', ' дней']) }}
              </div>
            </div>
          </div>
          <div class="calculator__col">
            <div class="calc-pay__title">
              Оплата
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                Стоимость доставки
              </div>
              <div class="calc-pay__item__text-cost">
                <div class="d-flex align-items-center justify-content-end">
                  {{ totalPrice }}
                  <svg
                    v-if="!isDirectionKzKz"
                    class="ml-2"
                    width="16px"
                    height="16px"
                  >
                    <use xlink:href="#rouble" />
                  </svg>
                  <svg
                    v-else
                    width="16"
                    height="16"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M5.33594 3.5H18.6329V4.99925H5.33594V3.5ZM12.7651 21.3215H11.2351V7.99774H5.33594V6.49849H18.6329V7.99774H12.7651V21.3215Z"
                      fill="#50616F"
                    />
                  </svg>
                </div>
                <div
                  v-if="calcImport && totalPriceImport && !isDirectionKzKz"
                  class="calc-pay__item__text-cost__muted"
                >
                  ({{ totalPriceImport }} {{ currencyName }})*
                </div>
              </div>
            </div>
            <div class="calc-pay__item">
              <div class="calc-pay__item__title">
                К оплате:
              </div>
              <div class="calc-pay__item__text-cost-big">
                <div class="d-flex align-items-center justify-content-end">
                  {{ totalPrice }}
                  <svg
                    v-if="!isDirectionKzKz"
                    width="24px"
                    height="24px"
                  >
                    <use xlink:href="#rouble" />
                  </svg>
                  <svg
                    v-else
                    width="24"
                    height="24"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M5.33594 3.5H18.6329V4.99925H5.33594V3.5ZM12.7651 21.3215H11.2351V7.99774H5.33594V6.49849H18.6329V7.99774H12.7651V21.3215Z"
                      fill="#50616F"
                    />
                  </svg>
                </div>
                <div
                  v-if="calcImport && totalPriceImport && !isDirectionKzKz"
                  class="calc-pay__item__text-cost-big__muted"
                >
                  ({{ totalPriceImport }} {{ currencyName }}*)
                </div>
              </div>
            </div>
            <div
              v-if="calcImport && totalPriceImport&& !isDirectionKzKz"
              class="calc-pay__text-cb"
            >
              *Итоговая стоимость может отличаться от&nbsp;указанной&nbsp;&mdash; она зависит от&nbsp;курса банка-эмитента.
            </div>
            <div class="calculator-form__fields">
              <div class="calculator-form__field calculator-form__field_full-width">
                <div
                  v-if="!isDirectionKzKz"
                  class="calc-radio-btn calc-radio-btn_fifth-step"
                  :class="{ 'active': paySystem === PAY_SYSTEM.RUSSIAN }"
                  @click="paySystem = PAY_SYSTEM.RUSSIAN"
                >
                  <svg
                    v-if="paySystem === PAY_SYSTEM.RUSSIAN"
                    class="calc-radio-btn__icon"
                    width="24px"
                    height="24px"
                  >
                    <use xlink:href="#select-on" />
                  </svg>
                  <svg
                    v-else
                    class="calc-radio-btn__icon"
                    width="24px"
                    height="24px"
                  >
                    <use xlink:href="#select-off" />
                  </svg>
                  <div class="calc-package-item__left">
                    <div class="calc-package-item__desc">
                      <div class="calc-radio-btn__name">
                        Картой РФ
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="calc-radio-btn calc-radio-btn_fifth-step"
                  :class="{ 'active': paySystem === PAY_SYSTEM.OTHER }"
                  @click="paySystem = PAY_SYSTEM.OTHER"
                >
                  <svg
                    v-if="paySystem === PAY_SYSTEM.OTHER"
                    class="calc-radio-btn__icon"
                    width="24px"
                    height="24px"
                  >
                    <use xlink:href="#select-on" />
                  </svg>
                  <svg
                    v-else
                    class="calc-radio-btn__icon"
                    width="24px"
                    height="24px"
                  >
                    <use xlink:href="#select-off" />
                  </svg>
                  <div class="calc-package-item__left">
                    <div class="calc-package-item__desc">
                      <div class="calc-radio-btn__name">
                        {{ isDirectionKzKz ? 'Оплата картой' : 'Иностранными картами' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul class="calculator-form__fields mt-0">
              <li>
                <span
                  class="field-checkbox payment-info__checkbox mb-0"
                  :class="{'field-item__error': validations.orderPIP.sender.payment_agreement.$error}"
                >
                  <input
                    id="payment_agreement"
                    v-model="orderPIP.sender.payment_agreement"
                    class="field-checkbox__input"
                    type="checkbox"
                    name="payment_agreement"
                    @change="validations.orderPIP.sender.payment_agreement.$touch()"
                  >
                  <label
                    class="field-checkbox__label payment-info__checkbox-label"
                    for="payment_agreement"
                  >
                    <span>
                      Нажимая “Оплатить” вы соглашаетесь c
                      <a
                        class="calc__link-text"
                        :href="personalAgreementLink"
                        target="_blank"
                      >&nbsp;условиями оферты</a>
                    </span>
                  </label>

                  <span
                    v-if="validations.orderPIP.sender.payment_agreement.$error"
                    class="field__error"
                  >
                    Подтвердите обработку данных
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="calculator-options calculator-options_delivery">
          <div class="calculator-options__info row mx-0">
            <div
              v-if="orderPIP.sender.country === COUNTRY_CODES.RUSSIA"
              class="accordion accordion_calc mt-5"
            >
              <div class="accordion__items calculator-options__items">
                <CalculatorServicesOptions
                  v-if="!hideServices && checkDeliveryMethod && checkDeliveryMethod.services"
                  :delivery-services-list="checkDeliveryMethod.services"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      :is-loading="isLoading"
      @stepValidation="onBtnPaymentClick"
      @step-back="$emit('step-back')"
    >
      <template #btnNext>
        Оплатить
      </template>
    </CalcNavDesktop>
    <CalcNavMobile
      v-else
      :is-loading="isLoading"
      @stepValidation="onBtnPaymentClick"
      @step-back="$emit('step-back')"
    >
      <template #btnNext>
        Оплатить
      </template>
    </CalcNavMobile>
  </div>
</template>

<script>
import CalcNavDesktop from './components/CalcNavDesktop.vue';
import CalcNavMobile from './components/CalcNavMobile.vue';
import deviceInfo from '../../helpers/device';
import CalculatorServicesOptions from './CalculatorServicesOptions.vue';

import num2str from '../../helpers/num2str';
import currencyConversion from '../../helpers/payment';
import { paymentInit } from '../../models/calculator-pip';
import { COUNTRY_CODES } from '../../helpers/constans';

const PAY_SYSTEM = {
  RUSSIAN: 1,
  OTHER: 2,
};

export default {
  name: 'CalculatorPIPPayStepView',
  components: { CalcNavMobile, CalcNavDesktop, CalculatorServicesOptions },
  props: {
    checkDeliveryMethod: {
      type: Object,
      default: () => ({}),
    },
    orderPIP: {
      type: Object,
      required: true,
    },
    orderCalcPIP: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    totalPrice: {
      type: String,
      required: true,
    },
    cbrDaily: {
      type: Array,
      default: () => ([]),
    },
    orderNum: {
      type: String,
      required: true,
    },
    errorDictionary: {
      type: Object,
      required: true,
    },
    paymentId: {
      type: String,
      required: true,
    },
    absoluteUrl: {
      type: String,
      default: '',
    },
    hideServices: {
      type: Boolean,
      default: false,
    },
    personalAgreementLink: {
      type: String,
      required: true,
    },
    calcImport: {
      type: Boolean,
      default: false,
    },
    isDirectionKzKz: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    num2str,
    isLoading: false,
    isDisabled: false,
    paySystem: PAY_SYSTEM.RUSSIAN,
    PAY_SYSTEM,
  }),
  computed: {
    ...deviceInfo,
    cbrDailySelected() {
      return this.cbrDaily.find((item) => item.numeric_code === this.orderPIP.sender.country);
    },
    totalPriceImport() {
      if (!this.totalPrice || !this.cbrDailySelected || !Object.keys(this.cbrDailySelected).length) return '';
      return currencyConversion(this.totalPrice, this.cbrDailySelected.quantity, this.cbrDailySelected.exchange_rate);
    },
    currencyName() {
      if (!this.totalPrice || !this.cbrDailySelected || !Object.keys(this.cbrDailySelected).length) return '';
      return this.cbrDailySelected.symbol_code;
    },
  },
  beforeMount() {
    this.validations.orderPIP.sender.payment_agreement.$reset();

    if (this.isDirectionKzKz) {
      this.paySystem = PAY_SYSTEM.OTHER;
    }
  },
  created() {
    this.COUNTRY_CODES = COUNTRY_CODES;
  },
  methods: {
    onBtnPaymentClick() {
      if (!this.orderPIP.sender.payment_agreement) {
        this.validations.orderPIP.sender.payment_agreement.$touch();
        return;
      }
      this.isLoading = true;
      this.isDisabled = true;
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step_pay' } }));
      paymentInit(this.orderPIP, this.errorDictionary, this.orderNum, this.totalPrice, this.paymentId, this.orderCalcPIP, this.paySystem, this.isDirectionKzKz)
        .then((data) => {
          if (this.isDirectionKzKz && data.redirect_url) {
            window.location = data.redirect_url;
          } else if (data.redirectUrl) {
            window.location = data.redirectUrl;
          } else {
            throw new Error('Нет ссылки на платёжный кабинет');
          }
        })
        .catch((errArr) => {
          this.$emit('error', errArr.message);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDisabled = false;
        });
    },
  },
};
</script>
